import { ReactElement, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';

import InfoIcon from '../assets/info-icon.svg?react';

interface ITooltipProps extends Omit<TooltipProps, 'children' | 'color'> {
  children?: ReactElement | ReactNode;
  color?: (theme: Theme) => string;
  containerClassName?: string;
  size?: number;
}

export function Tooltip({
  className,
  children,
  color,
  size,
  placement = 'top',
  containerClassName,
  ...restProps
}: ITooltipProps): JSX.Element {
  const { classes, cx } = useStyles();

  return (
    <MuiTooltip
      {...restProps}
      classes={{
        popper: className,
        ...restProps.classes,
        tooltip: classes.tooltip,
      }}
      enterTouchDelay={0}
      placement={placement}
    >
      <Box
        className={cx(classes.container, containerClassName)}
        color={color}
        component="div"
      >
        {children || (
          <Box
            color={color}
            component={InfoIcon}
            sx={theme => ({
              width: size,
              height: size,

              '&:hover': {
                color: theme.palette.primary.main,
              },
            })}
          />
        )}
      </Box>
    </MuiTooltip>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color:
      theme.palette.mode === 'light'
        ? theme.palette.text.secondary
        : theme.palette.divider,
    width: 'max-content',

    '&&:hover': {
      color: theme.palette.primary.main,

      '& > span, & > svg': {
        color: theme.palette.primary.main,
      },
    },
  },

  tooltip: {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.common.white,
  },
}));
